import React__default from 'react';
import { QuantityItem } from './components/QuantityItem/QuantityItem.js';
import { QuantityContainerButton } from './components/QuantityContainerButton/QuantityContainerButton.js';

const QuantityContainer = ({ items , selected , itemView , handleClick  })=>{
    const Component = itemView || QuantityItem;
    return /*#__PURE__*/ React__default.createElement("div", {
        className: "quantity-container"
    }, items.map((item)=>/*#__PURE__*/ React__default.createElement(QuantityContainerButton, {
            key: item.value,
            QuantityContainerComponent: Component,
            item: item,
            isSelected: selected.value === item.value,
            onClick: ()=>handleClick(item)
        })
    ));
};

export { QuantityContainer };
//# sourceMappingURL=QuantityContainer.js.map
